import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { awaitsendlist as _awaitsendlist, cancelTimedSend, batchNotic, saveBatchSend } from 'api/payroll/pay-slip';
import { getPayMonthList as _getPayMonthList, payrollSubProjectList as _payrollSubProjectList } from '@/api/payroll';
export default {
  data: function data() {
    return {
      loading: true,
      dialogMerge: false,
      isMerge: false,
      mergeCount: 0,
      dialogBatch: false,
      batchData: [],
      batch_month: this.$route.query.month2 || '',
      pay_month: this.$route.query.month2 || '',
      wageLength: -1,
      wageList: [],
      // 方案列表
      multipleSelection: [],
      // 选中数据
      subProjectIds: [],
      // 选中数据id
      a: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.$route.query.month2) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return _this.getPayMonthList();
          case 3:
            _context.next = 5;
            return _this.awaitsendlist();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getPayMonthList: function getPayMonthList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res$data$, _res$data$2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _getPayMonthList({
                search_name: '',
                sub_project_status: '3'
              });
            case 2:
              res = _context2.sent;
              if (res && res.code === 1) {
                _this2.pay_month = ((_res$data$ = res.data[0]) === null || _res$data$ === void 0 ? void 0 : _res$data$.child[0]) || _this2.$util.fmtDate('yyyy-MM');
                _this2.batch_month = ((_res$data$2 = res.data[0]) === null || _res$data$2 === void 0 ? void 0 : _res$data$2.child[0]) || _this2.$util.fmtDate('yyyy-MM');
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onBatch: function onBatch() {
      this.dialogBatch = true;
      this.payrollSubProjectList();
    },
    payrollSubProjectList: function payrollSubProjectList() {
      var _this3 = this;
      _payrollSubProjectList({
        pay_month: this.batch_month,
        sub_project_status: '3'
      }).then(function (_ref) {
        var data = _ref.data;
        _this3.batchData = data;
      });
    },
    clickMerge: function clickMerge() {
      var _this4 = this;
      var query = {
        sub_project_id: this.subProjectIds,
        settlement_type: this.multipleSelection[0].settlement_type,
        tax_deduction_status: this.multipleSelection[0].tax_deduction_status,
        pay_month: this.batch_month,
        is_combine: this.isMerge ? '2' : '1'
      };
      saveBatchSend(query).then(function (_ref2) {
        var data = _ref2.data;
        query.sub_project_id = data.id;
        delete query.pay_month;
        delete query.is_combine;
        _this4.goToDetail(query, '3', 'merge');
      });
    },
    // 确认批量发送
    clickConfirm: function clickConfirm() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _yield$batchNotic, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return batchNotic({
                sub_project_id: _this5.subProjectIds
              });
            case 2:
              _yield$batchNotic = _context3.sent;
              data = _yield$batchNotic.data;
              _this5.dialogMerge = data.is_show;
              _this5.mergeCount = data.is_count;
              if (!_this5.dialogMerge) _this5.clickMerge();
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 选中工资条
    handleSelectionChange: function handleSelectionChange(val) {
      var _this6 = this;
      this.subProjectIds = [];
      val.forEach(function (item) {
        _this6.subProjectIds.push(item.sub_project_id);
      });
      this.multipleSelection = val;
    },
    selectable: function selectable(row) {
      // 当勾选其中一个税类型后，其他税类型的子项目勾选框禁止选中，取消勾选后，所有项目再开放选择
      var type = this.multipleSelection.length >= 1 ? this.multipleSelection[0].settlement_type : '';
      var tax_deduction_status = this.multipleSelection.length >= 1 ? this.multipleSelection[0].tax_deduction_status : '';
      return (row.settlement_type === type || !type) && (row.tax_deduction_status === tax_deduction_status || !tax_deduction_status);
    },
    // 工资条列表
    awaitsendlist: function awaitsendlist() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this7.pay_month) {
                _context4.next = 3;
                break;
              }
              _this7.$message.warning(_this7.$t('payroll_salary_28'));
              return _context4.abrupt("return");
            case 3:
              _this7.loading = true;
              _this7.$router.push({
                query: {
                  active: '2',
                  month2: _this7.pay_month
                }
              });
              _awaitsendlist({
                pay_month: _this7.pay_month
              }).then(function (res) {
                if (res && res.code === 1) _this7.wageList = res.data;
                _this7.wageLength = res.data.length;
              }).finally(function () {
                return _this7.loading = false;
              });
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    cacleSend: function cacleSend(item) {
      var _this8 = this;
      // 取消定时器
      this.$confirm(this.$t('pay_slip_47'), this.$t('pay_slip_11'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              cancelTimedSend({
                payslip_id: item.payslip_id
              }).then(function (res) {
                if (res && res.code === 1) {
                  _this8.awaitsendlist();
                  _this8.$message.success(res.message);
                }
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))).catch(function () {});
    },
    goToDetail: function goToDetail(item, state, type) {
      // 跳转配置页
      var api = '';
      if (state === '4') api = '/payroll/setpay-pay-slip/' + item.payslip_id;else if (state === '3') api = '/payroll/paywages-pay-slip/' + item.sub_project_id;else api = '/payroll/pay-send-results/' + item.payslip_id;
      var query = _objectSpread(_objectSpread({}, this.$route.query), {}, {
        month2: this.$route.query.month2 || this.batch_month,
        payslip_scheme_id: item.id,
        type: item.settlement_type,
        tax_deduction_status: item.tax_deduction_status,
        merge: type,
        state: state
      });
      this.$router.push({
        path: api,
        query: query
      });
    }
  }
};